import { render, staticRenderFns } from "./OzodMuddat.vue?vue&type=template&id=30ce836c&scoped=true&"
import script from "./OzodMuddat.vue?vue&type=script&lang=js&"
export * from "./OzodMuddat.vue?vue&type=script&lang=js&"
import style0 from "./OzodMuddat.vue?vue&type=style&index=0&id=30ce836c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ce836c",
  null
  
)

export default component.exports